import { render, staticRenderFns } from "./InventoryTableMobile.vue?vue&type=template&id=e18c1acc&scoped=true"
import script from "./InventoryTableMobile.vue?vue&type=script&lang=js"
export * from "./InventoryTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18c1acc",
  null
  
)

export default component.exports